
import React, { useEffect, useState } from "react";
import DashboardHeader from "@/components/DashboardHeader";
import ToggleInput from "@/components/toggle/Toggle";
import { API_ROUTES } from "@/services/environment";
import { GET, POST, } from "@/services/api";
import { useAppSelector } from "@/hooks/hook";
import 'react-datepicker/dist/react-datepicker.css';
import { useNavigate } from "react-router";
import { DeleteIcon, ShowIcon } from "@/utils/svgs";
import ChangesAlert from "@/components/alert/ChangesAlert";

interface props {
    businessId: string;

}

const ViewPackages: React.FC<props> = ({ businessId }) => {
    const navigate = useNavigate()
    const { refreshToken } = useAppSelector((store) => store.user);
    const { packages } = API_ROUTES;
    const [packagesData, setPackagesData] = useState<Array<any>>([]);
    const [activeId, setActiveId] = useState<string>("");
    const [alert, setAlert] = useState<boolean>(false);
    const [confirm, setConfirm] = useState<boolean>(false);


    const [loading, setLoading] = useState<boolean>(true);


    useEffect(() => {
        fetchData();
        // Clean-up function
        return () => {
            // Perform any clean-up (if needed)
        };
    }, []); // Empty dependency array to run effect only once on component mount

    const fetchData = async () => {
        // get all the packages data from the server
        try {
            const result = await GET(`${packages}/${businessId}`, refreshToken);
            setPackagesData(result.data)
            setLoading(false);
        } catch (err) {
            console.log(err);
            // setCustomError('discount', JSON.stringify( err));
        } finally {
            setLoading(false);
        }
    };



    // empty screen if there is no packages 
    if (packagesData.length == 0) {
        return null
    }

    // table view for packages list
    return (
        <div>
            <DashboardHeader title="Available Packages">
                {/* <div className="flex justify-end">
                    <Button onClick={() => navigate(`/create-company/?id=${businessId}`, { state: { step: 3, isNew: true } })}>Add New</Button>
                </div> */}
            </DashboardHeader>
            <div className="relative overflow-x-auto shadow-md sm:rounded-lg mt-4 overflow-y-auto max-h-96">
                <table className="w-full text-sm text-left rtl:text-right text-gray-500">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                        <tr>
                            <th scope="col" className=" px-2 sm:px-4 text-primary-red py-3">
                                Sr#.
                            </th>
                            <th scope="col" className=" px-2 sm:px-4 text-primary-red py-3">
                                Guest Per Bartender
                            </th>
                            <th scope="col" className=" px-2 sm:px-4 text-primary-red py-3">
                                Package Name
                            </th>
                            <th scope="col" className=" px-2 sm:px-4 text-primary-red py-3">
                                Type
                            </th>
                            <th scope="col" className=" px-2 sm:px-4 text-primary-red py-3">
                                Supplies
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            packagesData.map((item, index) => {
                                return (
                                    <tr key={index} className="odd:bg-white  even:bg-gray-50  border-b ">
                                        <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap ">
                                            {index + 1}
                                        </th>
                                        <td className="px-2 sm:px-4 py-4">
                                            {/* <img className="h-14 w-14 object-cover rounded-full " src={item.image} /> */}
                                            {item?.guests_per_bartender}
                                        </td>
                                        <td className="px-2 sm:px-4 py-4 min-w-40">
                                            {item?.name}
                                        </td>
                                        <td className="px-2 sm:px-4 py-4">
                                            {item?.type}
                                        </td>
                                        <td className="px-2 sm:px-4 py-4 min-w-56">
                                            {item?.supplies.map((data: string) => {
                                                return (
                                                    data + ", "
                                                )
                                            })}
                                        </td>
                                        {/* <td className="px-2 sm:px-4 py-4">
                                            <div onClick={() => { packagesData.length > 1 ? [setActiveId(item.id), setConfirm(true)] : setAlert(true) }} className="cursor-pointer" >
                                                <DeleteIcon />
                                            </div>

                                        </td> */}
                                    </tr>
                                )
                            })
                        }

                    </tbody>
                </table>
            </div>
            <ChangesAlert
                title={"Delete Alert"}
                desc={`You cant delete the last Package!`}
                negativeButtonText={"Okay"}
                handleDiscardChanges={() => { setAlert(false) }}
                isOpen={alert} />

        </div>
    );
};



export default ViewPackages;








